import React from 'react';
import { WatermarkBackgroundMobile } from '@contract-root/admin-react/src/containers/SystemAdminModule/WatermarkLogoModule/WatermarkBackgroundMobile';
import { formatDate } from '@ifca-root/react-component/src/helpers/StringNumberFunction/formatDate';
import { amtStr } from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter';
import DMainHeader from 'containers/AccountLedgerModule/AccountLedgerMobileView/Template/DMainHeader';
import FooterAmt from 'containers/AccountLedgerModule/helper/Components/MobileView/FooterAmt';
import { InfoTemplateLeft } from 'containers/AccountLedgerModule/helper/Components/MobileView/InfoTemplateLeft';
import { InfoTemplateLR } from 'containers/AccountLedgerModule/helper/Components/MobileView/InfoTemplateLR';
import { InfoTemplateRight } from 'containers/AccountLedgerModule/helper/Components/MobileView/InfoTemplateRight';
import LedgerTable1 from 'containers/AccountLedgerModule/helper/Components/MobileView/LedgerTable1';

export const InvoiceToSubconTemplate = (props: any) => {
  const {
    addressMobileView,
    submittedByLedger,
    printPdf,
    fontSize,
    invoicetoSubconData,
  } = props;

  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  // CX: POB subscribers present the ITS item tax-free with a separate
  // "Admin Charges" section (markup + admin fee), matching the detail screen.
  const projectPurchasePOBSubscriber = JSON.parse(
    localStorage.getItem('projectPurchasePOBSubscriber'),
  );

  return (
    <div id={printPdf ? 'pdf-data-print' : 'pdfdata'}>
      <DMainHeader docDetail={invoicetoSubconData} />
      <div style={{ textAlign: 'center', fontSize }}>
        <b>INVOICE</b>
      </div>
      <div style={{ paddingBottom: '5px' }}></div>
      <InfoTemplateLR
        leftItem={
          <>
            <InfoTemplateLeft title={'To'} data={addressMobileView} />
            <div style={{ paddingBottom: '5px' }}></div>
            <InfoTemplateLeft
              title={'Contract Title'}
              data={invoicetoSubconData?.subcontract?.title}
            />
            <InfoTemplateLeft
              title={'Contact Person'}
              data={
                invoicetoSubconData?.subcontract?.contact?.[0]?.name ??
                invoicetoSubconData?.subcontractor?.contactPerson?.[0]?.name
              }
            />
            <InfoTemplateLeft
              title={'Contact No.'}
              data={
                invoicetoSubconData?.subcontract?.contact?.[0]?.contactNo ??
                invoicetoSubconData?.subcontractor?.contactPerson?.[0]
                  ?.contactNo
              }
            />

            {invoicetoSubconData?.isEInvoice === true && (
              <>
                <InfoTemplateLeft
                  title={'TIN No.'}
                  data={invoicetoSubconData?.subcontractor?.tinNo}
                />
                <InfoTemplateLeft
                  title={'Registration No.'}
                  data={invoicetoSubconData?.subcontractor?.registrationNo}
                />
                <InfoTemplateLeft
                  title={'Email'}
                  data={invoicetoSubconData?.subcontractor?.email}
                />
                <InfoTemplateLeft
                  title={'Unique Identifier No.'}
                  data={invoicetoSubconData?.eInvoiceIrbmUniqueID}
                />
              </>
            )}
          </>
        }
        rightItem={
          <>
            <InfoTemplateRight
              title={'Invoice No.'}
              data={invoicetoSubconData?.docNo}
            />
            <InfoTemplateRight
              title={'Invoice Date'}
              data={formatDate(invoicetoSubconData?.docDate)}
            />
            <InfoTemplateRight
              title={'Credit Term (Days)'}
              data={invoicetoSubconData?.subcontract?.creditTerm}
            />
            <InfoTemplateRight title={'Prepared By'} data={submittedByLedger} />
          </>
        }
      />
      <WatermarkBackgroundMobile />
      <div>
        {projectPurchasePOBSubscriber ? (
          <ITSAdminChargesTables
            data={invoicetoSubconData}
            fontSize={fontSize}
          />
        ) : !!invoicetoSubconData?.invoiceToSubconItem ? (
          <LedgerTable1
            glItem={invoicetoSubconData?.invoiceToSubconItem}
            baseAmt={amtStr(
              invoicetoSubconData?.invoiceToSubconItem?.docAmt -
                invoicetoSubconData?.invoiceToSubconItem?.taxAmt,
            )}
            taxRate={invoicetoSubconData?.invoiceToSubconItem?.taxRate}
            taxAmt={amtStr(invoicetoSubconData?.invoiceToSubconItem?.taxAmt)}
            docAmt={amtStr(invoicetoSubconData?.invoiceToSubconItem?.docAmt)}
            materialData={invoicetoSubconData?.invoiceToSubconItem}
            taxData={invoicetoSubconData?.invoiceToSubconItem?.taxScheme}
            desc={
              invoicetoSubconData?.description ??
              invoicetoSubconData?.invoiceToSubconItem?.remarks
            }
          />
        ) : (
          ''
        )}
      </div>
      <br />
      <br />
      <br />
      <br />
      <div>
        <FooterAmt
          docAmt={invoicetoSubconData?.docAmt}
          userData={user}
          eInvoiceData={invoicetoSubconData}
        />
      </div>
    </div>
  );
};

// CX: ITS for POB - Section 1 material item (tax-free) + Section 2 Admin
// Charges (markup and/or backcharge-policy admin fee, each non-zero driven).
const ITSAdminChargesTables = ({ data, fontSize }: any) => {
  const items = data?.invoiceToSubconItem ?? [];
  const markupTotal = items.reduce(
    (sum, it) => sum + (parseFloat(it?.markupAmt) || 0),
    0,
  );
  // manually added items (no principalAmt) carry their own tax in their doc
  // amt, so only DO/GRN-generated items feed the Admin Charges tax
  const markupTaxTotal = items.reduce(
    (sum, it) =>
      sum + (it?.principalAmt != null ? parseFloat(it?.taxAmt) || 0 : 0),
    0,
  );
  const markupRef = items.find(it => parseFloat(it?.markupAmt) > 0);
  const adminFee = Number(data?.adminFee ?? 0);
  const adminFeeTax = Number(data?.adminFeeTax ?? 0);
  const adminFeeRate =
    adminFee > 0 ? Math.round((adminFeeTax / adminFee) * 100) : null;

  const adminRows = [
    ...(markupTotal > 0
      ? [{ base: markupTotal, tax: markupTaxTotal, rate: markupRef?.taxRate ?? null }]
      : []),
    ...(adminFee > 0
      ? [{ base: adminFee, tax: adminFeeTax, rate: adminFeeRate }]
      : []),
  ];

  const cell = {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
  } as const;

  return (
    <>
      <table style={{ width: '100%', fontSize, borderCollapse: 'collapse' }}>
        <tbody>
          <tr>
            <th style={{ ...cell, textAlign: 'left', width: '40%' }}>
              Description
            </th>
            <th style={cell}>Base Amt</th>
            <th style={{ ...cell, textAlign: 'end' }}>Doc Amt</th>
          </tr>
          {items.map((gl, i) => {
            // manual items (no principalAmt) carry their own tax in doc amt
            const base =
              gl?.principalAmt != null
                ? Number(gl?.principalAmt)
                : Number(gl?.docAmt) - Number(gl?.taxAmt);
            const doc =
              gl?.principalAmt != null
                ? Number(gl?.principalAmt)
                : Number(gl?.docAmt);
            return (
              <tr style={{ textAlign: 'center' }} key={i}>
                <td style={{ textAlign: 'left' }}>
                  {gl?.revenueCategory?.name ?? gl?.costItem?.name ?? 'N/A'}
                </td>
                <td>{amtStr(base)}</td>
                <td style={{ textAlign: 'end' }}>{amtStr(doc)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {adminRows.length > 0 && (
        <>
          <div style={{ fontSize, fontWeight: 'bold', marginTop: 8 }}>
            Admin Charges
          </div>
          <table
            style={{ width: '100%', fontSize, borderCollapse: 'collapse' }}
          >
            <tbody>
              <tr>
                <th style={{ ...cell, textAlign: 'left', width: '40%' }}>
                  Item
                </th>
                <th style={cell}>Base Amt</th>
                <th style={cell}>Tax Amt</th>
                <th style={{ ...cell, textAlign: 'end' }}>Doc Amt</th>
              </tr>
              {adminRows.map((r, i) => (
                <tr style={{ textAlign: 'center' }} key={i}>
                  <td style={{ textAlign: 'left' }}>Admin Charges</td>
                  <td>{amtStr(r.base)}</td>
                  <td>
                    {r.rate != null
                      ? `${amtStr(r.tax)} (${r.rate}%)`
                      : amtStr(r.tax)}
                  </td>
                  <td style={{ textAlign: 'end' }}>{amtStr(r.base + r.tax)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </>
  );
};
